/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRuler3 = createReactComponent("ruler-3", "IconRuler3", [
  [
    "path",
    {
      d: "M19.875 8c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 8v2", key: "svg-1" }],
  ["path", { d: "M6 8v3", key: "svg-2" }],
  ["path", { d: "M12 8v3", key: "svg-3" }],
  ["path", { d: "M18 8v3", key: "svg-4" }],
  ["path", { d: "M15 8v2", key: "svg-5" }]
]);

export { IconRuler3 as default };
//# sourceMappingURL=IconRuler3.js.map
